import { AgGridColumnDef, GridSettingsContext as IGridSettingsContext } from '@tassat/common-definitions';
import { UserValidationRecord } from '@tassat/fred-definitions';

import { SideListGridOptions } from 'SharedComponents/sideList';

import { GridSettingsContext } from './gridSettingsContext';
import { SideListLayout } from './sideListLayout';

export type SidelistLayoutFormOptions = IGridSettingsContext['form'];

export interface ISideListLayoutProps {
    children?: React.ReactNode;
    rowData: any[];
    columnDefs: AgGridColumnDef[];
    gridOptions: SideListGridOptions;
    formOptions?: SidelistLayoutFormOptions;
    pendingSSORequest?: string;
    pendingSSORequestModalOpen?: boolean;
    editPendingSsoUser?: (ssoUser: UserValidationRecord) => void;
    isSSOPendingBtnAllowed?: boolean;
    isDeleteModalOpen?: boolean;
    userRequestToDelete?: UserValidationRecord;
    onCloseDeleteUserPendingModal?: () => void;
    handleDeleteUserPending?: (userSsoPending: UserValidationRecord) => void;
    handlePendingSSORequestModalOpen?: () => void;
}

export default SideListLayout;
export { GridSettingsContext };